import { render } from "./mvt-market.vue?vue&type=template&id=256427f2"
import script from "./mvt-market.js?vue&type=script&lang=js"
export * from "./mvt-market.js?vue&type=script&lang=js"

import "./mvt-market.vue?vue&type=style&index=0&id=256427f2&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__